import { type FC, useContext } from 'react';
import { type SystemProps } from '@chakra-ui/system';

import { BentoLayoutSize } from 'common/bento/lib/layout';
import useLayoutSizeQuery from 'common/bento/lib/layout/useLayoutSizeQuery';

import NavigationContext from './NavigationContext';
import NavigationDesktop from './NavigationDesktop';
import NavigationMobile from './NavigationMobile';

export interface NavigationProps extends SystemProps {
  onPrev?: () => void;
  onClose?: () => void;
  isCollapsed?: boolean;
}

/**
 * Renders the navigation for the onboarding, including the onboarding timeline and user controls.
 */
const Navigation: FC<NavigationProps> = ({ isCollapsed, ...props }) => {
  const isDesktop = useLayoutSizeQuery(BentoLayoutSize.md);

  const navigationContext = useContext(NavigationContext);

  return isDesktop ? (
    <NavigationDesktop navigation={navigationContext} {...props} />
  ) : (
    <NavigationMobile
      isCollapsed={isCollapsed}
      navigation={navigationContext}
      {...props}
    />
  );
};

export default Navigation;
